import {
  Card,
  Heading,
  IconTick,
  List,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import type { ListingProduct } from 'src/generated/graphql';

const features = [
  'Your ad is featured at the top of our recommended business emails which we send daily to buyers.',
  'Your ad remains boosted for the life of your ad.',
];

interface EmailBoostProductDetailsProps {
  product: ListingProduct;
}

const EmailBoostProductDetails = ({
  product,
}: EmailBoostProductDetailsProps) => (
  <Card data={{ testid: 'email-boost-product-details' }}>
    <Stack space="large" align="left">
      <Heading level="3">Email boost your ads to reach more buyers</Heading>

      <Stack space="medium">
        <Heading level="4">What&apos;s included:</Heading>

        <List
          type="icon"
          icon={<IconTick tone="positive" />}
          size="large"
          space="large"
        >
          {features.map((feature, key) => (
            <Text key={key}>{feature}</Text>
          ))}
        </List>
      </Stack>

      <Text size="large" data={{ testid: 'email-boost-product-details-price' }}>
        ${product.cost / 100} + GST
      </Text>
    </Stack>
  </Card>
);

export default EmailBoostProductDetails;
